const HLS_MIME_TYPES = new Set([
    'application/vnd.apple.mpegurl',
    'application/x-mpegurl',
]);

const HLS_URL_HINTS = ['.m3u8', '/hls/', 'format=hls', 'playlist.m3u8'];

export const isHlsMimeType = (mimeType = '') => {
    if (!mimeType) return false;
    return HLS_MIME_TYPES.has(String(mimeType).split(';')[0].trim().toLowerCase());
};

export const isHlsUrl = (url = '') => {
    if (!url) return false;
    const loweredUrl = String(url).toLowerCase();
    return HLS_URL_HINTS.some((hint) => loweredUrl.includes(hint));
};

const getSourceType = (url, mimeType, mediaType = 'video') => {
    if (isHlsMimeType(mimeType) || isHlsUrl(url)) {
        return 'application/x-mpegURL';
    }

    if (mimeType) return mimeType;

    const extension = String(url || '').split('.').pop()?.toLowerCase() || '';
    if (!extension) return `${mediaType}/mp4`;
    return `${mediaType}/${extension}`;
};

export const resolvePlaybackSource = ({
    mediaUrl,
    streamUrl,
    mimeType,
    streamMimeType,
    mediaType = 'video',
}) => {
    const resolvedStreamUrl = streamUrl || '';
    if (resolvedStreamUrl) {
        return {
            src: resolvedStreamUrl,
            type: getSourceType(resolvedStreamUrl, streamMimeType || mimeType, mediaType),
            isAdaptive: isHlsMimeType(streamMimeType || mimeType) || isHlsUrl(resolvedStreamUrl),
        };
    }

    const resolvedMediaUrl = mediaUrl || '';
    return {
        src: resolvedMediaUrl,
        type: getSourceType(resolvedMediaUrl, mimeType, mediaType),
        isAdaptive: isHlsMimeType(mimeType) || isHlsUrl(resolvedMediaUrl),
    };
};

export const getPreferredStreamUrl = (media = null) => {
    if (!media || typeof media !== 'object') return null;
    return (
        media.hls_manifest_url ||
        media.hls_signed_url ||
        media.hls_url ||
        media.stream_signed_url ||
        media.stream_url ||
        media.playback_url ||
        null
    );
};

export const getPreferredStreamMimeType = (media = null) => {
    if (!media || typeof media !== 'object') return null;
    if (media.stream_type === 'hls' || media.is_adaptive_stream === true) {
        return 'application/x-mpegURL';
    }
    return media.mime_type || null;
};
